'use strict';

var AnnotationTool = require('../annotation_tool');

var EmphasisTool = AnnotationTool.extend({
  name: "emphasis"
});

module.exports = EmphasisTool;



/*****************
 ** WEBPACK FOOTER
 ** ./~/substance/surface/tools/emphasis_tool.js
 ** module id = 239
 ** module chunks = 0
 **/